var _rect, _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteAnalysisProject(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 40,
    viewBox: "0 0 56 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 40,
    rx: 8,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9285 11.2143H23.7142C23.8321 11.2143 23.9285 11.1178 23.9285 11V11.2143H32.0714V11C32.0714 11.1178 32.1678 11.2143 32.2857 11.2143H32.0714V13.1428H33.9999V11C33.9999 10.0545 33.2312 9.28571 32.2857 9.28571H23.7142C22.7687 9.28571 21.9999 10.0545 21.9999 11V13.1428H23.9285V11.2143ZM37.4285 13.1428H18.5714C18.0973 13.1428 17.7142 13.5259 17.7142 14V14.8571C17.7142 14.975 17.8107 15.0714 17.9285 15.0714H19.5464L20.208 29.0804C20.2508 29.9937 21.0062 30.7143 21.9196 30.7143H34.0803C34.9964 30.7143 35.7491 29.9964 35.7919 29.0804L36.4535 15.0714H38.0714C38.1892 15.0714 38.2857 14.975 38.2857 14.8571V14C38.2857 13.5259 37.9026 13.1428 37.4285 13.1428ZM33.8741 28.7857H22.1258L21.4776 15.0714H34.5223L33.8741 28.7857Z",
    fill: "#8F8F8F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteAnalysisProject);
export default __webpack_public_path__ + "static/media/delete-analysis-project.a0bd3d63f77f39e2078842838777f1b5.svg";
export { ForwardRef as ReactComponent };